import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function About() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        {/* Breadcrumb */}
        <nav aria-label="面包屑导航" className="bg-background-50 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-4">
            <ol className="flex items-center gap-2 text-xs text-foreground-600 flex-wrap">
              <li><Link to="/" className="hover:text-primary-500 transition-colors">首页</Link></li>
              <li className="text-foreground-400">/</li>
              <li className="text-foreground-900 font-medium">关于我们</li>
            </ol>
          </div>
        </nav>

        {/* Page Header */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              关于片多多影视
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              致力于为广大影迷打造最优质的免费高清在线观影平台
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-6">品牌介绍</h2>
              <div className="space-y-4">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  片多多影视成立于2024年，是一家专注于提供高清免费在线影视服务的平台。我们的使命是打破影视观看的付费壁垒，让每一位影迷都能自由、便捷地享受高品质的观影体验。经过两年多的快速发展，片多多影视已经积累了超过2,000万活跃用户，日均播放量突破800万次。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  我们深知，影视作品不仅是娱乐，更是文化的载体和情感的表达。因此，片多多影视始终坚持正版授权，与国内外多家影视公司和内容提供商建立了深度合作关系，确保平台上的每一部作品都来源可靠、画质精良。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  片多多影视团队由一群热爱电影、热爱生活的年轻人组成。我们来自不同的背景，但拥有共同的信念：用技术的力量让好电影被更多人看到。我们的技术团队不断优化播放体验和推荐算法，内容团队每天精选优质影视内容，力求为每一位用户带来最好的观影体验。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">我们的核心优势</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                    <i className="ri-star-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">完全免费</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">无需注册、无需付费、无需会员，打开即看。我们通过广告合作维持运营，用户享受纯净免费的观影体验。</p>
                </div>
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-4k-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">超清画质</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">支持720P至4K多种画质选择，先进的视频编码技术确保每一帧都清晰细腻，给你影院般的视觉享受。</p>
                </div>
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                    <i className="ri-speed-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">流畅不卡顿</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">智能CDN加速和码率调节技术，自动匹配最佳画质，确保在任何网络环境下都能流畅播放，告别卡顿烦恼。</p>
                </div>
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                    <i className="ri-database-2-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">海量资源</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">50,000+影视资源覆盖电影、电视剧、综艺、动漫、纪录片等十几个分类，满足不同观众的多样化需求。</p>
                </div>
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-refresh-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">极速更新</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">专业内容更新团队7x24小时待命，热门电影电视剧上线后24小时内即可观看，绝不让你错过任何精彩。</p>
                </div>
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                    <i className="ri-device-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">全平台支持</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">PC端、平板、手机全平台完美适配，随时随地打开浏览器就能看，无需下载任何APP，方便快捷。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* User Reviews */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-2 text-center">用户口碑</h2>
              <p className="text-sm text-foreground-600 text-center mb-8">超过2,000万用户的真实评价</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1,2,3,4,5].map((i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "片多多影视真的是我用过的最好用的免费影视平台！资源更新超快，画质也好，最重要的是完全不卡顿。已经推荐给身边所有朋友了！"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">— 影迷小王，使用1年</p>
                </div>
                <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1,2,3,4,5].map((i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "作为一个追剧狂人，片多多影视简直就是我的福音。电视剧更新速度快得惊人，而且还支持4K超清，大屏观看体验一级棒！"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">— 追剧达人小美，使用8个月</p>
                </div>
                <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1,2,3,4,5].map((i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "以前看电影总要到处找资源，自从用了片多多影视，再也不用东奔西跑了。分类清晰，搜索方便，免费还高清，五星推荐！"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">— 电影爱好者老张，使用6个月</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-2 text-center">联系我们</h2>
              <p className="text-sm text-foreground-600 text-center mb-8">如有任何问题或建议，欢迎随时联系我们</p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-primary-100 text-primary-500 mb-3">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-xs text-foreground-600">contact@pianduoduo.com</p>
                </div>
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-accent-100 text-accent-600 mb-3">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服热线</h3>
                  <p className="text-xs text-foreground-600">400-888-8888</p>
                  <p className="text-xs text-foreground-500 mt-1">工作日 9:00 - 18:00</p>
                </div>
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-secondary-100 text-secondary-600 mb-3">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                  <p className="text-xs text-foreground-600">北京市朝阳区光华路15号院1号楼</p>
                </div>
              </div>

              {/* Contact Form */}
              <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-6 text-center">在线留言</h3>
                <form
                  data-readdy-form
                  action="https://readdy.ai/api/form/d9od11obdkpk99j7guig"
                  method="POST"
                  className="max-w-xl mx-auto"
                  onSubmit={(e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const formData = new FormData(form);
                    const honeypot = formData.get('phone_alt');
                    if (honeypot && String(honeypot).trim() !== '') {
                      alert('留言已提交，我们会尽快回复！');
                      return;
                    }
                    fetch(form.action, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                    })
                      .then(async (res) => {
                        const text = await res.text();
                        return { ok: res.ok, text };
                      })
                      .then(({ ok, text }) => {
                        let serverMsg = '';
                        try {
                          const parsed = JSON.parse(text);
                          serverMsg = parsed?.meta?.message || parsed?.message || '';
                        } catch { /* ignore */ }
                        if (ok && (!serverMsg || !serverMsg.includes('spam'))) {
                          alert('留言已提交，我们会尽快回复！');
                          form.reset();
                        } else {
                          alert(serverMsg || '提交失败，请稍后再试');
                        }
                      })
                      .catch(() => alert('提交失败，请检查网络后重试'));
                  }}
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <input
                      type="text"
                      name="name"
                      placeholder="您的姓名"
                      required
                      className="px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="您的邮箱"
                      required
                      className="px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    />
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="website-alt-field"
                  />
                  <textarea
                    name="message"
                    placeholder="请输入您的留言内容（500字以内）"
                    rows={5}
                    maxLength={500}
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none mb-4"
                  ></textarea>
                  <button
                    type="submit"
                    className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    提交留言
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://pianduoduo.com',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
              },
            ],
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于片多多影视',
            description: '片多多影视致力于为广大影迷打造最优质的免费高清在线观影平台',
            mainEntity: {
              '@type': 'Organization',
              name: '片多多影视',
              url: 'https://pianduoduo.com',
              description: '片多多影视提供海量高清免费影视资源，不卡顿在线观看',
              contactPoint: {
                '@type': 'ContactPoint',
                telephone: '400-888-8888',
                contactType: 'customer service',
                availableLanguage: 'Chinese',
              },
              address: {
                '@type': 'PostalAddress',
                streetAddress: '光华路15号院1号楼',
                addressLocality: '北京',
                addressRegion: '朝阳区',
                addressCountry: 'CN',
              },
            },
          }),
        }}
      />
    </>
  );
}